import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ShopifyRegular from './shopify-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ShopifyRegular {...validProps} />;
}
SvgComponent.iconName = 'shopifyRegular';

export const ShopifyRegularIcon = svgIconWrapper(SvgComponent);
